<template>
  <div class="dialog">
    <el-dialog :visible.sync="changVisible" title="头像上传样式" center width="600px" :before-close="$onClose" destroy-on-close @close="close()">
      <div>
        <p>
          <span>尺寸&nbsp;</span>
          <el-input v-model="width" size="mini" style="width: 60px" type="number" @keyup.native="proving(1)" />
          <span>*</span>
          <el-input v-model="height" size="mini" style="width: 60px" type="number" @keyup.native="proving(2)" />
          <span>px</span>
        </p>
        <!-- <p style="margin-top: 10px">
          <span>格式&nbsp;</span>
          <el-radio v-model="type" label="jpg">jpg</el-radio>
          <el-radio v-model="type" label="png">png</el-radio>
        </p> -->
        <p style="margin-top: 10px">
          <span>大小&nbsp;</span>
          <el-input v-model="size" size="mini" style="width: 60px" type="number" @keyup.native="proving(3)" />
          <span>M</span>
        </p>
      </div>

      <div class="footDialog">
        <el-button style="width: 106px; float: right" size="small" type="primary" v-preventReClick @click="ok()">确定</el-button>
        <el-button style="width: 106px; float: right; margin-right: 15px" size="small" v-preventReClick @click="close()">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from '@/config/config'
import { isEmpty } from '@/utils/strUtils'
import preventReClick from '@/utils//preventReClick' //防多次点击，重复提交
import * as Constant from '@/utils/constant.js'

export default {
  data() {
    return {
      urlPath: URL_PATH,
      changVisible: false,
      width: 0,
      height: 0,
      type: 'jpg',
      size: 1
    }
  },
  methods: {
    $onClose(done) {
      done()
    },
    close() {
      this.changVisible = false
    },
    //页面初始化时加载的事件
    show(info) {
      this.info = info
      this.changVisible = true
      this.getInfo()
    },
    getInfo: function () {
      this.$api
        .getAlumniPhotoStyle({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.width = data.Data.alumniCardPhotoWidth
          this.height = data.Data.alumniCardPhotoHeight
          this.type = data.Data.alumniCardPhotoType
          this.size = data.Data.alumniCardPhotoMaxSize
        })
    },
    ok: function () {
      this.$api
        .updateAlumniPhotoStyle({
          token: localStorage.getItem('token'),
          alumniCardPhotoWidth: this.width,
          alumniCardPhotoHeight: this.height,
          alumniCardPhotoType: this.type,
          alumniCardPhotoMaxSize: this.size
        })
        .then(({ data }) => {
          this.close()
        })
        .catch(({ error }) => {})
    },
    proving(index) {
      switch (index) {
        case 1:
          // this.info.price=this.info.price.replace(/[^\d\.]/g,'')
          this.width = this.width.replace(/\D/g, '')
          break
        case 2:
          this.height = this.height.replace(/\D/g, '')
          break
        case 3:
          this.size = this.size.replace(/\D/g, '')
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>
 <style lang="less">
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type='number'] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>


// WEBPACK FOOTER //
// src/components/dialog/photoExamineStyleDialog.vue